import { ReactNode, useEffect } from "react";
import styles from "./Page.module.css"
import { Header } from "./Header"
import cs from "clsx"
import { useStoreShared } from "../../../store";

interface Props {
  children: ReactNode | ReactNode[]
  title?: string
  className?: string
}

export function Page({ children, title, className }: Props) {
  const isTelekom = sessionStorage.getItem("currentClientUuid") === "39d60ce7-6e1a-4cab-87ed-047e6323e262";

  return (
    <main className={cs((isTelekom ? styles.root_telekom : styles.root), className)}>
      <Header className={styles.header} title={title} />
      <section className={styles.content}>{children}</section>
    </main>
  )
}
